if (!customElements.get("m-localization-form")) {
  class MLocalizationForm extends HTMLElement {
    constructor() {
      super();
      const select = this.querySelector('[data-localization-select]');
      select && select.addEventListener('change', (e) => {
        const value = e.target.value
        const form = select.closest('[data-localization-form]')
        const input = form.querySelector('input[data-localization-input]')
        // Grossner: limba aleasă setează și țara (moneda pieței), vezi snippets/language-switcher.liquid
        const grOpt = select.options[select.selectedIndex]
        const grCountry = form.querySelector('input[data-gr-country-input]')
        if (grCountry && grOpt && grOpt.dataset.grCountry) grCountry.setAttribute('value', grOpt.dataset.grCountry)
        input && input.setAttribute('value', value)
        input && form.submit()
      });
    }
  }
  customElements.define('m-localization-form', MLocalizationForm);
}